import React from "react"
import {FieldViewProps} from "../../../render/view"

export default function FieldTimeReportId_ViewProperty(props: FieldViewProps) {
    const value = props.field.getViewValue(props.model)

    const classes = Classes("ui5-property txt-truncate not-selectable", props.className)

    return <span className={classes}>#{value}</span>
}
